import { Suspense } from 'react';

import CircularProgress from '@mui/material/CircularProgress';

export default function ({ children }) {
    return <Suspense fallback={<CircularProgress />}>{children}</Suspense>;
}
